<template>
  <div
    :aria-expanded="active"
    class="accordion"
    role="button"
    tabindex="0"
    @click="onClicked"
    @keydown.enter="onClicked"
    @keydown.space="(event: Event) => onClicked(event, true)"
  >
    <div :class="accordionClassesText">{{ accordionText }}</div>
    <div class="accordion__arrow-button" :class="{ 'accordion__arrow-button__rotated': !active }">
      <IconChevroneUpMedium
        v-if="size === 'medium' || size === 'large'"
        :class="accordionClassesIcon"
      />
      <IconChevroneUpSmall
        v-if="size === 'small' || size === 'extrasmall'"
        :class="accordionClassesIcon"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { toRefs, computed } from 'vue'
import IconChevroneUpMedium from '../assets/icons/IconChevroneUpMedium.vue'
import IconChevroneUpSmall from '../assets/icons/IconChevroneUpSmall.vue'
interface EMITS {
  (e: 'onClicked')
}
interface Props {
  accordionText: string
  size: string
  active: boolean
}
const props = defineProps<Props>()
const { accordionText, size, active } = toRefs(props)
const emits = defineEmits<EMITS>()
const accordionClassesText = computed(() => {
  if (size.value === 'medium') return 'accordion__text'
  if (size.value === 'small') return 'accordion__text__small'
  if (size.value === 'large') return 'accordion__text__large'
  if (size.value === 'extrasmall') return 'accordion__text__extrasmall'
  else return ''
})

const accordionClassesIcon = computed(() => {
  if (size.value === 'medium') return 'accordion__arrow-button__icon'
  if (size.value === 'extrasmall') return 'accordion__arrow-button__icon__small'
  if (size.value === 'small') return 'accordion__arrow-button__icon__small'
  if (size.value === 'large') return 'accordion__arrow-button__icon__large'
  else return ''
})

function onClicked(event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  emits('onClicked')
}
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
.accordion {
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 4px;
  &__arrow-button {
    display: flex;
    cursor: pointer;
    &__icon {
      color: variables.$color-primary;
      position: relative;
      width: 16px;
      height: 16px;
      &__small {
        color: variables.$color-primary;
      }
      &__large {
        color: variables.$color-primary;
      }
    }
    &__rotated {
      transform: rotate(-180deg);
    }
  }
  &__text {
    color: variables.$color-primary;
    @include font-mixins.desktop-bold-paragraph;
    &__extrasmall {
      color: variables.$color-primary;
      @include font-mixins.desktop-bold-tiny;
    }
    &__small {
      color: variables.$color-primary;
      @include font-mixins.desktop-bold-label;
    }
    &__large {
      color: variables.$color-primary;
      @include font-mixins.desktop-bold-label;
    }
  }
}
</style>
